import { render } from "./editTruck.vue?vue&type=template&id=4ac8a1d2&scoped=true"
import script from "./editTruck.vue?vue&type=script&lang=js"
export * from "./editTruck.vue?vue&type=script&lang=js"

import "./editTruck.vue?vue&type=style&index=0&id=4ac8a1d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ac8a1d2"]])

export default __exports__